/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './Splash.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import {
  getStats,
  getGeoIp,
  getLeaderboard,
} from '../actions';


class CityList extends Component {
  render() {
    let cities = this.props.cities;
    cities.sort((a, b) => a.name.localeCompare(b.name));
    let nodes = cities.map(city => {
      return (
        <div key={city.id} className="city">
          <Link to={'/c/' + city.slug}>{city.name}
          {city.province && <span>, {city.province}</span>}</Link>
        </div>
      );
    });

    return (
      <div className="cities">
        {nodes}
      </div>
    );
  }
}


class ProvinceList extends Component {
  render() {
    let cities = this.props.cities;

    let citiesByProvince = {};
    for (let city of cities) {
      let province = city.province;
      if (!citiesByProvince[province]) {
        citiesByProvince[province] = [];
      }
      citiesByProvince[province].push(city);
    }

    let nodes = [[], [], []];
    let provinces = Object.keys(citiesByProvince);
    provinces.sort((a, b) => a.localeCompare(b));
    // for (let province of provinces) {
    for (let i = 0; i < provinces.length; i++) {
      let province = provinces[i];
      let provinceName = citiesByProvince[province][0].provinceName;
      let idx = 0;
      if (i > provinces.length / 3) {
        idx = 1;
      }
      if (i > provinces.length * (2/3)) {
        idx = 2;
      }
      console.log('idx', idx);
      nodes[idx].push(
        <div className="province">
          <div className="province-name">{provinceName}</div>
          <CityList
            key={province}
            cities={citiesByProvince[province]}
          />
        </div>
      );
    }

    return (
      <div className="provinces">
        <div className="province-list">{nodes[0]}</div>
        <div className="province-list">{nodes[1]}</div>
        <div className="province-list">{nodes[2]}</div>
      </div>
    );
  }
}


class GeoList extends OzComponent {

  static need = [
    ['stats', getStats, () => { return [null, {}, { full: 1 }]}],
  ]

  state = {};

  render() {
    let stats = this.props.stats || { counts: {}, cities: []};
    let cities = stats.cities || [];

    let citiesByCountry = {};
    for (let city of cities) {
      let country = city.country;
      if (!citiesByCountry[country]) {
        citiesByCountry[country] = [];
      }
      citiesByCountry[country].push(city);
    }

    let nodes = [];
    for (let country of Object.keys(citiesByCountry)) {
      let countryName = citiesByCountry[country][0].countryName;
      nodes.push(
        <div className="country">
          <div className="country-name">{countryName}</div>
          <ProvinceList
            key={country}
            cities={citiesByCountry[country]}
          />
        </div>
      );
    }

    return (
      <Wrapper className="Splash" title="Full City List">
        <div className="countries">{nodes}</div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    stats: state.get.stats,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getStats,
    getGeoIp,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeoList);



/** WEBPACK FOOTER **
 ** ./src/components/GeoList.js
 **/